import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Loader from "./components/Loader";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Footer from "./components/Footer";
import FAQSP from "./pages/FAQSP";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import EaterOnCheffy from "./pages/EaterOnCheffy";
import CookerOnCheffy from "./pages/CookerOnCheffy";
import JoinUs from "./pages/JoiinUs";
import Security from "./pages/Security";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  // const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => setIsLoading(false), 4000); // Simulate loading time
  //   return () => clearTimeout(timer);
  // }, []);

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faqs" element={<FAQSP />} />
        <Route path="/cooker-cheffy" element={<CookerOnCheffy />} />
        <Route path="/eater-cheffy" element={<EaterOnCheffy />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/security" element={<Security />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
